var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChallengesModalBackground = function SvgChallengesModalBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 161,
    viewBox: "0 0 560 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_8855)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 161,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.4355 -59.6406C-5.78284 -64.0589 4.00262 -61.4369 8.4209 -53.7842L145.963 184.446C150.381 192.098 147.759 201.884 140.107 206.302L40.7587 263.66C33.106 268.079 23.3206 265.457 18.9023 257.804L-118.64 19.5743C-123.058 11.9216 -120.436 2.13614 -112.783 -2.28214L-13.4355 -59.6406Z",
    fill: "url(#paint0_linear_603_8855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.4355 -59.6406C-5.78284 -64.0589 4.00262 -61.4369 8.4209 -53.7842L145.963 184.446C150.381 192.098 147.759 201.884 140.107 206.302L40.7587 263.66C33.106 268.079 23.3206 265.457 18.9023 257.804L-118.64 19.5743C-123.058 11.9216 -120.436 2.13614 -112.783 -2.28214L-13.4355 -59.6406Z",
    fill: "url(#paint1_linear_603_8855)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_8855",
    x1: 77.1919,
    y1: 65.3307,
    x2: -49.8687,
    y2: 138.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_8855",
    x1: 77.1919,
    y1: 65.3307,
    x2: -49.8687,
    y2: 138.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_8855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 161,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChallengesModalBackground);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYwIiBoZWlnaHQ9IjE2MSIgdmlld0JveD0iMCAwIDU2MCAxNjEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF82MDNfODg1NSkiPgo8cmVjdCB3aWR0aD0iNTYwIiBoZWlnaHQ9IjE2MSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTS0xMy40MzU1IC01OS42NDA2Qy01Ljc4Mjg0IC02NC4wNTg5IDQuMDAyNjIgLTYxLjQzNjkgOC40MjA5IC01My43ODQyTDE0NS45NjMgMTg0LjQ0NkMxNTAuMzgxIDE5Mi4wOTggMTQ3Ljc1OSAyMDEuODg0IDE0MC4xMDcgMjA2LjMwMkw0MC43NTg3IDI2My42NkMzMy4xMDYgMjY4LjA3OSAyMy4zMjA2IDI2NS40NTcgMTguOTAyMyAyNTcuODA0TC0xMTguNjQgMTkuNTc0M0MtMTIzLjA1OCAxMS45MjE2IC0xMjAuNDM2IDIuMTM2MTQgLTExMi43ODMgLTIuMjgyMTRMLTEzLjQzNTUgLTU5LjY0MDZaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNjAzXzg4NTUpIi8+CjxwYXRoIGQ9Ik0tMTMuNDM1NSAtNTkuNjQwNkMtNS43ODI4NCAtNjQuMDU4OSA0LjAwMjYyIC02MS40MzY5IDguNDIwOSAtNTMuNzg0MkwxNDUuOTYzIDE4NC40NDZDMTUwLjM4MSAxOTIuMDk4IDE0Ny43NTkgMjAxLjg4NCAxNDAuMTA3IDIwNi4zMDJMNDAuNzU4NyAyNjMuNjZDMzMuMTA2IDI2OC4wNzkgMjMuMzIwNiAyNjUuNDU3IDE4LjkwMjMgMjU3LjgwNEwtMTE4LjY0IDE5LjU3NDNDLTEyMy4wNTggMTEuOTIxNiAtMTIwLjQzNiAyLjEzNjE0IC0xMTIuNzgzIC0yLjI4MjE0TC0xMy40MzU1IC01OS42NDA2WiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzYwM184ODU1KSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNjAzXzg4NTUiIHgxPSI3Ny4xOTE5IiB5MT0iNjUuMzMwNyIgeDI9Ii00OS44Njg3IiB5Mj0iMTM4LjY4OSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRjFGMkZFIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiIHN0b3Atb3BhY2l0eT0iMC4yNSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfNjAzXzg4NTUiIHgxPSI3Ny4xOTE5IiB5MT0iNjUuMzMwNyIgeDI9Ii00OS44Njg3IiB5Mj0iMTM4LjY4OSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRjFGMkZFIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiIHN0b3Atb3BhY2l0eT0iMC4yNSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzYwM184ODU1Ij4KPHJlY3Qgd2lkdGg9IjU2MCIgaGVpZ2h0PSIxNjEiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";